export const zendeskHistory = {
	page: {
		title: "Mis tickets",
		subtitle: "Da seguimiento al estado y a las respuestas de los tickets que abriste.",
	},
	filters: {
		placePlaceholder: "Filtrar por lugar",
		statusPlaceholder: "Filtrar por estado",
		searchPlaceholder: "Buscar por asunto o ID",
	},
	table: {
		columns: {
			createdAt: "Creado el",
			id: "ID",
			subject: "Asunto",
			placeName: "Lugar",
			updatedAt: "Última actualización",
			status: "Estado",
		},
		viewDetails: "Ver detalles",
	},
	pagination: {
		pageSizeLabel: "Resultados por página",
	},
	emptyState: {
		noData: {
			title: "No se encontraron tickets",
			description:
				"Aún no has abierto ningún ticket. Cuando necesites soporte, abre un ticket y haz seguimiento aquí.",
		},
		noFilters: {
			title: "Ningún ticket coincide con los filtros",
			description:
				"Prueba a ajustar la búsqueda, el lugar, el estado o el periodo para encontrar lo que buscas.",
		},
	},
	status: {
		open: "Abierto",
		ongoing: "En curso",
		closed: "Resuelto",
	},
	detail: {
		title: "Detalles del ticket",
		loading: "Cargando detalles del ticket...",
		createdAt: "Creado el {{date}}",
		closedAt: "Ticket cerrado el {{date}}",
		downloadAttachment: "Descargar adjunto",
		requesterLabel: "Tú",
	},
};
